<template>
  <div>
    <ValidationObserver ref="formAdd">
      <form @submit.prevent="">
        <div class="breadcrumb-area pos-relative w-100">
          <!-- title -->
          <div class="row">
            <h5 class="col-sm-6 col-12">UPLOAD THÔNG TIN KPI</h5>
            <div class="col-sm-6 col-12 d-flex justify-content-end align-items-center">
              <b-button class="ml-2" @click="$router.push({ name: 'kpi record list' })">
                Quay lại
              </b-button>
            </div>
          </div>
          <!-- content -->
          <div class="">
            <div class="row w-100">
              <div class="col-sm-6 mt-2">
                <ValidationProvider rules="required" vid="serviceType" name="Loại dịch vụ">
                  <div class="form-group row" slot-scope="{ errors }">
                    <label for="" class="col-sm-3 col-form-label"
                      >Loại dịch vụ<span style="color: red"> *</span></label
                    >
                    <div class="col-sm-9">
                      <!-- @change="listDevice = []" -->
                      <Select2
                        v-model="formData.serviceType"
                        :options="serviceTypeOption"
                        placeholder="Chọn loại dịch vụ"
                        @change="onChangeServiceType"
                      >
                      </Select2>
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider rules="required" vid="regionId" name="Vùng">
                  <div class="form-group row" slot-scope="{ errors }">
                    <label for="" class="col-sm-3 col-form-label"
                      >Vùng<span style="color: red"> *</span></label
                    >
                    <div class="col-sm-9">
                      <Select2
                        v-model="formData.regionId"
                        :options="optionsRegion"
                        placeholder="Chọn vùng"
                      >
                      </Select2>
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <div class="row mb-4">
                  <div class="col-3">Tên file tải lên</div>
                  <div class="col-9">{{ fileName }}</div>
                </div>
                <ValidationProvider rules="" vid="note" name="Ghi chú">
                  <div class="form-group row" slot-scope="{ errors }">
                    <label for="" class="col-sm-3 col-form-label">Ghi chú</label>
                    <div class="col-sm-9">
                      <b-form-textarea
                        v-model="formData.note"
                        placeholder="Nhập ghi chú..."
                        rows="1"
                      ></b-form-textarea>
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <input
            style="display: none"
            ref="uploadFileExcel"
            @change="uploadFileExcel"
            type="file"
          />
          <div class="">
            <div class="d-flex justify-content-between align-items-center">
              <div>Danh sách TB cần ghi nhận KPI</div>
              <div class="btn-group float-right">
                <button
                  class="font-medium f12 btn btn-outline-secondary"
                  @click="downloadFileTemplate"
                >
                  Tải file mẫu
                </button>
                <button
                  class="font-medium f12 btn btn-outline-secondary"
                  v-if="dataPermission.includes('CNPS_SUR_PERF_KPI_FILE_UPLOAD')"
                  @click="importFile"
                >
                  Import file
                </button>
              </div>
            </div>
          </div>
          <!-- table -->
          <div>
            <div class="my-2 d-flex justify-content-between align-items-end">
              <div class="">Tổng: {{ listDevice.length }} TB</div>
            </div>
            <b-table
              :fields="fieldsTable"
              :items="listDevice"
              responsive
              hover
              sticky-header
              :fixed="true"
              :bordered="true"
              style="max-height: calc(100vh - 500px)"
              :per-page="perPage"
              :current-page="currentPage"
              show-empty
              empty-text="Không có dữ liệu!"
            >
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(packageType)="data">
                <p v-if="data.item.packageType">Loại gói: {{ data.item.packageType }}</p>
                <p v-if="data.item.duration">Thời hạn: {{ data.item.duration }}</p>
              </template>

              <template #cell(action)="data">
                <b-button
                  size="sm"
                  variant="primary"
                  v-if="canDeviceKpiUpdateMx"
                  @click="changeDevices(data.item, formData.serviceType)"
                  class="mr-2"
                  >Sửa</b-button
                >
                <b-button
                  size="sm"
                  variant="danger"
                  v-if="canDeviceKpiCancelMx"
                  @click="deleteDevice(data.item)"
                  >Xoá</b-button
                >
              </template>
            </b-table>
            <div class="d-flex justify-content-end">
              <b-pagination
                class="mt-1"
                v-model="currentPage"
                :total-rows="listDevice.length"
                :per-page="perPage"
                aria-controls="my-table"
              ></b-pagination>
            </div>
          </div>
        </div>
      </form>
      <ModalEditDevice
        v-model="showModalDevice"
        @submit="submitFormDevice"
        :dataEdit="deviceData"
        :serviceType="serviceType"
      ></ModalEditDevice>
    </ValidationObserver>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import kpiRecordMx from './kpiRecordMx'
  import Config from '@/thirdParty/config'
  import { StaffService } from '@/services/staff.service'
  import { DeviceService } from '../../services/device.service'

  export default {
    mixins: [kpiRecordMx],
    data() {
      return {
        Config,
        deviceData: {},
        serviceType: '',
        showModalDevice: false,
        showLoading: false,
        formData: {},
        dataUser: JSON.parse(localStorage.getItem('userData')),
        fullDataUser: {},
        optionsRegion: [],
        fileName: '',

        // table
        perPage: 10,
        currentPage: 1,
        listDevice: [],
        fieldsTable: [
          { key: 'index', label: 'STT', class: 'text-center' },
          { key: 'merchantEmail', label: 'Email MC', thStyle: '' },
          { key: 'contractCode', label: 'Mã hợp đồng', thStyle: '' },
          { key: 'appendixCode', label: 'Mã phụ lục', thStyle: '' },
          { key: 'service', label: 'Dịch vụ', thStyle: '' },
          { key: 'packageType', label: 'Loại gói & Thời hạn' },
          { key: 'categoryName', label: 'Tên TB', thStyle: '' },
          { key: 'serial', label: 'Serial TB', thStyle: '' },
          { key: 'receiptCode', label: 'Mã phiếu thu', thStyle: '' },
          { key: 'transactionCode', label: 'Mã giao dịch', thStyle: '' },
          { key: 'month', label: 'Tháng tính KPI' },
          { key: 'kpi', label: 'Số KPI' },
          { key: 'emailSale', label: 'Email CVKD', thStyle: '' },
          { key: 'note', label: 'Ghi chú', thStyle: '' },
          {
            key: 'action',
            label: 'Thao tác',
            fixIndex: 999,
            class: 'text-center',
            thStyle: 'min-width: 100px',
          },
        ],
        serviceTypeOption: [
          { id: 'PAYMENT', text: 'Thanh toán' },
          { id: 'SELL', text: 'Bán hàng' },
        ],
      }
    },
    created() {
      this.fetchUser()
    },
    methods: {
      async fetchUser() {
        try {
          const response = await StaffService.getStaffById({
            userId: this.dataUser.userId,
          })
          if (response.success) {
            this.fullDataUser = {
              ...response.data,
            }
          }
          this.getAllRegionForUser(response.data)
        } catch (error) {
          console.log(error)
        }
      },
      getAllRegionForUser({ region, regionName }) {
        const result = []
        const regionNameArr = regionName.split(',')
        console.log({ region, regionNameArr })
        if (region?.length && regionNameArr?.length) {
          for (let i = 0; i < region.length; i++) {
            const id = region[i]
            const text = regionNameArr[i]
            result.push({ id, text })
          }
        }
        this.optionsRegion = result
      },
      async downloadFileTemplate() {
        try {
          const serviceType = this.formData.serviceType
          if (!serviceType) {
            this.showFailMx('Vui lòng chọn loại dịch vụ muốn tải file mẫu.')
            return
          }
          this.showLoading = true
          const params = {
            typeService: serviceType,
          }
          await DeviceService.orderKpiDownloadFileTemplate(params)
        } catch (error) {
          console.log(error)
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },

      // upload
      importFile() {
        const serviceType = this.formData.serviceType
        if (!serviceType) {
          this.showFailMx('Vui lòng chọn loại dịch vụ muốn import file.')
          return
        }
        this.$refs.uploadFileExcel.click()
      },
      async uploadFileExcel(file) {
        if (file.target.files.length === 0) return
        const allowedExtensions = /(\.xls|\.xlsx|\.csv|\.ods)$/i
        const checkFomat = allowedExtensions.exec(file.target.files[0].name)
        if (!checkFomat) {
          this.showFailMx('Định dạng không hợp lệ !')
          this.$refs.uploadFileExcel.value = null
          return
        }
        const formdata = new FormData()
        formdata.append('file', file.target.files[0])
        formdata.append('type', this.formData.serviceType)
        formdata.append('regionId', this.formData.regionId)
        if (this.formData.note) formdata.append('note', this.formData.note)
        try {
          this.showLoading = true
          const res = await DeviceService.deviceKpiReadFile(formdata)
          if (res.code === 1000) {
            this.$router.push('/kpi-record/upload/detail/' + res.data.fileServiceId)
          } else {
            this.showFailMx(res.message)
          }
        } catch (e) {
          this.showFailMx(e.message)
        } finally {
          this.$refs.uploadFileExcel.value = null
          this.showLoading = false
        }
      },
      async dowloadFileError(reqs) {
        try {
          this.showLoading = true
          const params = {
            kpiExcels: reqs,
            typeService: this.formData.serviceType,
          }
          await DeviceService.orderKpiDownloadFileError(params)
        } finally {
          this.showLoading = false
        }
      },

      async deleteDevice(device) {
        const flag = await this.approveMx(
          `Bạn có chắc chắn muốn xoá thiết bị có serial: ${device.serial}`
        )
        if (!flag) return
        this.listDevice = this.listDevice.filter(e => e.index !== device.index)
      },
      changeDevices(device, serviceType) {
        if (!device || !serviceType) {
          console.log({ device, serviceType })
          this.showFailMx('Không có đủ thông tin thiết bi')
          return
        }
        this.serviceType = serviceType
        this.deviceData = device ? { ...device } : null
        this.showModalDevice = true
      },
      canCreateFileKpi() {
        return this.dataPermission.includes('CNPS_SUR_PERF_KPI_FILE_CREATE')
      },
      async sendRequest() {
        const check = this.canCreateFileKpi()
        if (!check) {
          this.showFailMx('Không có quyền truy cập')
          return false
        }
        const isSuccess = await this.$refs.formAdd.validate()
        if (!isSuccess) return
        try {
          const regionName =
            this.optionsRegion.find(e => e.id === this.formData.regionId)?.text ?? ''
          const deviceKpis = this.listDevice.map(e => {
            const item = { ...e }
            delete item.index
            delete item.rowIndex
            delete item.message
            item.action = 'CREATE'
            return item
          })
          const params = {
            ...this.formData,
            regionName,
            filename: this.fileName,
            kpiAggregateReqs: deviceKpis,
            note: this.formData.note,
          }
          console.log(123, params)
          this.showLoading = true
          const response = await DeviceService.orderKpiCreate(params)
          if (response.code === 1000) {
            this.showSuccessMx('Tạo thành công')
            this.$router.push({ name: 'kpi record list' })
          } else {
            throw new Error(response.message)
          }
        } catch (error) {
          console.log(error)
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      async submitFormDevice({ data, serviceType }) {
        // console.log(123, data, serviceType)
        // check UPDATE
        let checkKpi = null
        if (serviceType === 'PAYMENT') {
          checkKpi = await this.checkDeviceKpiPaymentInfo(data)
          if (!checkKpi) {
            return false
          }
        }
        if (serviceType === 'SELL') {
          checkKpi = await this.checkDeviceKpiSellInfo(data)
          if (!checkKpi) {
            return false
          }
        }

        const index = this.listDevice.findIndex(e => e.index === data.index)
        if (index === -1) {
          this.showFailMx('không tìm thấy thiết bị')
          return
        }
        this.listDevice.splice(index, 1, data)
        this.showModalDevice = false
        await this.$nextTick()
        this.showSuccessMx('Chỉnh sửa thiết bị thành công!')
      },
      onChangeServiceType(event) {
        // xóa hết thiết bị nếu có
        if (this.listDevice.length) {
          this.showFailMx('Việc chọn lại loại dịch vụ sẽ xóa hết tất cả thiết bị đã upload')
          this.listDevice = []
          this.filename = ''
        }
      },
    },
  }
</script>

<style></style>
